<template lang="pug">
.compensacao-table
    .linha
        .coluna
            grid-table-component(:headers='headersCronograma', :data='cronogramas', :is-paginated='false')

                template(v-slot:validacao='{ item }')
                    validacao-component(
                        :tipo='item.tipo',
                        :item='item',
                        :tipos-documentos='tiposDocumentos',
                    )

                template(v-slot:area='{ item }')
                    span {{ item.area | decimal }}

                template(v-slot:inicio='{ item }')
                    span {{ item.inicio | data }}

                template(v-slot:fim='{ item }')
                    span {{ item.fim | data }}
    .linha(style='marginTop: "30px"')
        .coluna
            .cronograma-prada
                TimelineChartComponent(
                    :seriesData='seriesData'
                )


    modal-component(
        v-if='exibirModalDocumentos',
        title='Documentos',
        @close='exibirModalDocumentos = false'
    )
        AnaliseModalDocumentos(:etapa='itemSelecionado')

</template>

<script>

import ValidacaoComponent from '@/views/analise/components/ValidacaoComponent.vue';
import AnaliseModalDocumentos from '@/views/analise/components/AnaliseModalDocumentos.vue';
import TimelineChartComponent from '@/components/standard/TimelineChartComponent.vue';

export default {

    name: 'PradaCronogramaTable',

    components: {
        ValidacaoComponent,
        AnaliseModalDocumentos,
        TimelineChartComponent
    },

    props: {
        cronogramas: {
            type: Array,
        },

        tiposDocumentos: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            headersCronograma: [
                { text: 'Projeto', field: 'projeto' },
                { text: 'Área (ha)', field: 'area', width: '70px' },
                { text: 'Data de início', field: 'inicio' },
                { text: 'Data de conclusão', field: 'fim' },
                { text: 'Avaliação', field: 'validacao' },
            ],
            acao: [{ id: 'DOC', label: 'Documentos', icon: 'mdi-text-box-search-outline' }],
            exibirModalDocumentos: false,
            itemSelecionado: null,
            seriesData: null,
        };
    },

    async mounted() {
        // this.seriesData = await this.getCronogramaSeries(this.cronogramas);
        this.seriesData = await this.getCronogramaSeries2(this.cronogramas);
    },

    methods: {

        onAction(event, item) {
            if (event.id === 'DOC') {
                this.itemSelecionado = item;
                this.exibirModalDocumentos = true;
            }
        },

        getCronogramaSeries() {
            let series = [{
                data: []
            }];

            this.cronogramas.forEach((cronograma) => {
                let min = null;
                series[0].data.push({
                    x: cronograma.projeto,
                    y: [
                        new Date(cronograma.inicio).getTime(),
                        new Date(cronograma.fim).getTime(),
                    ],
                    rangeName: cronograma.projeto,
                    fillColor: "#" + Math.floor(Math.random() * 16777215).toString(16)
                });
            })

            return series;
        },

        getCronogramaSeries2() {
            let series = [];

            this.cronogramas.forEach((cronograma) => {

                let index = series.findIndex(d => d.name === cronograma.projeto);

                let seriesData = {
                    name: null,
                    data: []
                }

                if (index !== -1) {
                    series[index].data.push({
                        x: cronograma.projeto + " " + series[index].data.length,
                        y: [
                            new Date(cronograma.inicio).getTime(),
                            new Date(cronograma.fim).getTime(),
                        ],
                        rangeName: cronograma.projeto,
                        // fillColor: series[index].data[0].fillColor
                        fillColor: "#" + Math.floor(Math.random() * 16777215).toString(16)
                    });
                } else {
                    seriesData.name = cronograma.projeto;
                    seriesData.data.push({
                        x: cronograma.projeto,
                        y: [
                            new Date(cronograma.inicio).getTime(),
                            new Date(cronograma.fim).getTime(),
                        ],
                        rangeName: cronograma.projeto,
                        fillColor: "#" + Math.floor(Math.random() * 16777215).toString(16)
                    });
                    series.push(seriesData)
                }
            })

            return series;
        },

    },

};
</script>

<style lang="scss" scoped>
.cronograma-prada {
    max-height: 350px;
    overflow-y: auto;
}

.cronograma-prada::-webkit-scrollbar {
    width: 8px;
}

.cronograma-prada::-webkit-scrollbar-track {
    background-color: var(--primary-smoke);
}

.cronograma-prada::-webkit-scrollbar-thumb {
    border-radius: 100px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
</style>
